import { render, staticRenderFns } from "./FinishedTabel.vue?vue&type=template&id=2e8d8f4a&scoped=true&"
import script from "./FinishedTabel.vue?vue&type=script&lang=js&"
export * from "./FinishedTabel.vue?vue&type=script&lang=js&"
import style0 from "./FinishedTabel.vue?vue&type=style&index=0&id=2e8d8f4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d8f4a",
  null
  
)

export default component.exports